module.exports = "/assets/images/heart_dc6e28.svg";